



















import Base from './Base.vue';

export default Base.extend({
	name: 'OtevreneZakazky',
	components: {
		BaseFilterSestav: Base,
	},
});
